export const PRICE_RANGE = [0, 10000];
